import { useCallback, useEffect } from "react"
import { useSearchParams } from "react-router"

export const useParamFilters = () => {
    const [searchParams, setSearchParams] = useSearchParams()

    const getParamFilters = useCallback((param) => {
        const paramValue = searchParams.get(param)
        return paramValue ? paramValue : undefined
    }, [searchParams])

    const getAllParamFilters = useCallback((defaultValues = undefined) => {
        const filters = {}
        let hasFilters = false
        searchParams.forEach((value, key) => {
            filters[key] = value
            if (!hasFilters) hasFilters = true
        })



        return hasFilters ? { ...(defaultValues || {}), ...filters } : defaultValues
    }, [searchParams])


    return {
        getParamFilters,
        getAllParamFilters,
        setSearchParams
    }
}